import { useEffect, useRef } from 'react';
import L from "leaflet"
import "leaflet/dist/leaflet.css";
import "./EditorField.css";
import { clearOldFloorFeatures, ensureFloorMapFeatures, renderSpecialPolylineIf } from '../MapViewController';

function EditorField(props) {
	const mapContainerRef = useRef(null);
	const lmapRef = useRef(null);

	// The following values should be fixed
	// - props.onMapCreated
	// - props.willMapRemove
	const callbackProps = useRef(props);

	updateMapIf(lmapRef.current, props.editingFloor);

	useEffect( () => {
		if (lmapRef.current) { return; }
		if (mapContainerRef.current) {
			const lmap = L.map(mapContainerRef.current, {
				crs: L.CRS.Simple,
				minZoom: -5,
				maxZoom: 5
			});

			lmap._editingFloor = null;
			lmap._editingFloorSignature = -1;
			lmapRef.current = lmap;

			lmap.fitBounds([[-100, -100], [100, 100]]);
			lmap.on("layeradd", customFeatureDraw);
			callbackProps.current.onMapCreated?.(lmap);
		}

		const remove_handler = callbackProps.current.willMapRemove;
		return () => {
			remove_handler?.(lmapRef.current); 
			lmapRef.current?.remove();
			lmapRef.current = null;
		}

	}, []);

	return (<div className="bd-editor-map-container" ref={ mapContainerRef }>

	</div>);
}

function updateMapIf(lmap, editingFloor) {
	if (!lmap) { return; }

	let sig = -1;
	if (editingFloor) {
		sig = editingFloor.generateSignature();
	}

	if (lmap._editingFloor !== editingFloor ||
		lmap._editingFloorSignature !== sig
	) {
		clearOldFloorFeatures(lmap);
		ensureFloorMapFeatures(lmap, editingFloor);

		lmap._editingFloor = editingFloor;
		lmap._editingFloorSignature = sig;
	}
}

function customFeatureDraw(e) {
	const layer = e.layer;
	if (layer instanceof L.Polyline) {
		renderSpecialPolylineIf(layer);
	}
}

export default EditorField;